export default __webpack_public_path__ + "37bc8de84d70f83a96bda758b415f760.png";